export default "__VITE_ASSET__Dsl7ZEMe__"